import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const CustomerViewDtoServiceConfig = {
  name: "CustomerViewDto",
  annotations: []
} as ServiceConfig;